import script from "./VitaSubHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaSubHeader.vue?vue&type=script&lang=ts&setup=true"

import "./VitaSubHeader.vue?vue&type=style&index=0&id=10e61784&lang=scss"

const __exports__ = script;

export default __exports__